class Hospital {
  constructor(title, address, phoneNumber, latitude, longitude, cityId, hospitalDiagnosisIds, sepasCode) {
    this.title = title;
    this.address = address;
    this.phoneNumber = phoneNumber;
    this.latitude = latitude;
    this.longitude = longitude;
    this.cityId = cityId;
    this.hospitalDiagnosisIds = hospitalDiagnosisIds;
    this.sepasCode = sepasCode;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allHospitals: [],
      allHospitalsForOther: [],
      hospital: new Hospital('', '', '', null, null, null, [], ''),
      hospitalPaginationList: [],
      allActiveHospitals: [],
    };
  },
  methods: {
    getListOfHospitalsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllHospitals').then(() => {
        if (this.$store.state.hospitalModule.successFlag) {
          this.allHospitalsForOther = this.$store.state.hospitalModule.allHospitals;
          if (this.$route.name == 'user') {
            this.allUserHospitals = this.allHospitalsForOther;
            this.readyUserHospital();
          }
          if (this.$route.name == 'admissionMissions') {
            if (this.sendToHospitalModal == true) {
              this.readyMapHopitalLocations();
            }
          }
          if (this.$route.name == 'admissionMap') {
            this.readyMapHopitalLocations();
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.hospitalModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfHospitalsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.hospitalModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfHospitalsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfAllActiveHospitalsFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllActiveHospitals').then(() => {
        if (this.$store.state.hospitalModule.successFlag) {
          this.allActiveHospitals = this.$store.state.hospitalModule.allActiveHospitals;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.hospitalModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfAllActiveHospitalsFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.hospitalModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfAllActiveHospitalsFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllHospitals: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllHospitals').then(() => {
        if (this.$store.state.hospitalModule.successFlag) {
          this.allHospitals = this.$store.state.hospitalModule.allHospitals;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.hospitalModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllHospitals();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.hospitalModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllHospitals();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfHospitalsWithPagination: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getHospitalsWithPagination', {
          pageNumber: this.page,
          pageSize: this.pageSize,
          title: this.searchText,
          cityId: this.searchCityId,
        })
        .then(() => {
          if (this.$store.state.hospitalModule.successFlag) {
            this.hospitalPaginationList = [];
            let temp = this.$store.state.hospitalModule.hospitals;
            for (let i = 0; i < temp.length; i++) {
              let diagno = '';
              for (let j = 0; j < temp[i].diagnoses.length; j++) {
                diagno += temp[i].diagnoses[j].title + '،';
              }
              if (diagno) {
                diagno = this.removeLastCharechter(diagno);
              } else {
                diagno = '-';
              }
              this.hospitalPaginationList.push({
                counter: i + 1,
                title: temp[i].title ? temp[i].title : '-',
                city: temp[i].city ? temp[i].city.title : '-',
                phoneNumber: temp[i].phoneNumber ? temp[i].phoneNumber : '-',
                address: temp[i].address ? temp[i].address : '-',
                id: temp[i].id,
                diagno: diagno,
              });
            }
            if (this.load.val) {
              this.load.val = false;
            }
            this.totalPages = Number(this.$store.state.hospitalModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.hospitalModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.hospitalModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.hospitalModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getListOfHospitalsWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.hospitalModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getListOfHospitalsWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    setTotalPagesFun: function (totalPages) {
      if (this.$refs.pagination) {
        this.$refs.pagination.totalPages = Number(totalPages);
      } else {
        this.setTotalPagesFun(totalPages);
      }
    },
    addHospitalFunction: function () {
      if (!this.hospital.cityId) {
        this.snackText = 'شهرستان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.hospital.title) {
        this.snackText = 'عنوان بیمارستان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.hospital.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان بیمارستان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      if (this.hospitalphoneNumbers.length > 0) {
        for (let i = 0; i < this.hospitalphoneNumbers.length; i++) {
          this.hospital.phoneNumber += this.hospitalphoneNumbers[i].text;
          this.hospital.phoneNumber += ',';
        }
      }
      if (
        this.hospital.phoneNumber != null &&
        this.hospital.phoneNumber.length > 0 &&
        this.hospital.phoneNumber.charAt(this.hospital.phoneNumber.length - 1) == ','
      ) {
        this.hospital.phoneNumber = this.hospital.phoneNumber.substring(
          0,
          this.hospital.phoneNumber.length - 1,
        );
      }
      if (this.position && this.position.lat) {
        this.hospital.latitude = this.position.lat;
        this.hospital.longitude = this.position.lng;
      }
      this.$store.dispatch('addHospital', this.hospital).then(() => {
        if (this.$store.state.hospitalModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' بیمارستان با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.hospital = new Hospital('', '', '', null, null, null, [], '');
          this.position = null;
          this.hospitalphoneNumbers = [];
          this.getListOfHospitalsWithPagination();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.hospitalModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addHospitalFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.hospitalModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addHospitalFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getHospitalFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getHospital', id).then(() => {
        if (this.$store.state.hospitalModule.successFlag) {
          let temp = this.$store.state.hospitalModule.hospital;
          this.hospital.id = temp.id;
          this.hospital.title = temp.title;
          this.hospital.address = temp.address;
          this.hospital.sepasCode = temp.sepasCode;
          this.hospital.cityId = temp.city.id;
          if (temp.latitude) {
            this.hospital.latitude = temp.latitude;
            this.hospital.longitude = temp.longitude;
            this.position = { lat: temp.latitude, lng: temp.longitude };
            this.$refs?.fancemap?.mapObject?.flyTo([temp.latitude, temp.longitude], 16);
          }
          if (temp.phoneNumber.length > 0) {
            let phoneNumbers = temp.phoneNumber.split(',');
            for (let i = 0; i < phoneNumbers.length; i++) {
              this.hospitalphoneNumbers.push({
                text: phoneNumbers[i],
                id: i + 1,
              });
            }
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.hospitalModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getHospitalFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.hospitalModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getHospitalFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editHospitalFunction: function () {
      if (!this.hospital.cityId) {
        this.snackText = 'شهرستان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.hospital.title) {
        this.snackText = 'عنوان بیمارستان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.hospital.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان بیمارستان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      if (this.hospitalphoneNumbers.length > 0) {
        for (let i = 0; i < this.hospitalphoneNumbers.length; i++) {
          this.hospital.phoneNumber += this.hospitalphoneNumbers[i].text;
          this.hospital.phoneNumber += ',';
        }
      }
      if (
        this.hospital.phoneNumber != null &&
        this.hospital.phoneNumber.length > 0 &&
        this.hospital.phoneNumber.charAt(this.hospital.phoneNumber.length - 1) == ','
      ) {
        this.hospital.phoneNumber = this.hospital.phoneNumber.substring(
          0,
          this.hospital.phoneNumber.length - 1,
        );
      }
      if (this.position && this.position.lat) {
        this.hospital.latitude = this.position.lat;
        this.hospital.longitude = this.position.lng;
      }
      this.$store.dispatch('editHospital', this.hospital).then(() => {
        if (this.$store.state.hospitalModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.showAddEditModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfHospitalsWithPagination();
          this.snackText = ' بیمارستان با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.hospital = new Hospital('', '', '', null, null, null, [], '');
          this.position = null;
          this.hospitalphoneNumbers = [];
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.hospitalModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editHospitalFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.hospitalModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editHospitalFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteHospitalFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteHospital', this.hospitalId).then(() => {
        if (this.$store.state.hospitalModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfHospitalsWithPagination();
          this.snackText = ' بیمارستان با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.hospitalModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteHospitalFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.hospitalModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteHospitalFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfHospitalsForAdMissionFunction_OOLLDD: function (islaod = true) {
      if (this.$route.name == 'hospital800List') {
        if (!this.load.val && islaod) {
          this.load.val = true;
        }
      }
      if (this.$route.name == 'admissionMissions') {
        this.hospitalLoader = true;
      }
      this.$store.dispatch('getAllHospitalsAdMission').then(() => {
        if (this.$store.state.hospitalModule.successFlag) {
          let temp = this.$store.state.hospitalModule.allHospitalsAdmission;
          if (this.$route.name == 'admissionMissions') {
            this.readyHospitalTableData(temp);
          }
          if (this.$route.name == 'hospital800List') {
            this.readyData(temp);
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.hospitalModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfHospitalsForAdMissionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.hospitalModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfHospitalsForAdMissionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfHospitalsForAdMissionFunction: function (islaod = true) {
      if (this.$route.name == 'hospital800List') {
        if (!this.load.val && islaod) {
          this.load.val = true;
        }
      }
      if (this.$route.name == 'admissionMissions') {
        // gated on islaod so signal-driven refreshes don't flash the loader
        if (islaod) {
          this.hospitalLoader = true;
        }
      }
      return this.$store.dispatch('getAllHospitalsAdMission').then(() => {
        if (this.$store.state.hospitalModule.successFlag) {
          const temp = this.$store.state.hospitalModule.allHospitalsAdmission;
          if (this.$route.name == 'admissionMissions') {
            this.readyHospitalTableData(temp);
            this.hospitalLoader = false;
          }
          if (this.$route.name == 'hospital800List') {
            this.readyData(temp);
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$route.name == 'admissionMissions') {
            this.hospitalLoader = false;
          }
          if (this.$store.state.hospitalModule.errorStatus) {
            return this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                return this.getListOfHospitalsForAdMissionFunction(islaod);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.hospitalModule.error400) {
            return this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                return this.getListOfHospitalsForAdMissionFunction(islaod);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    //Diagnoses part
    getHospitalDiagnosisBaseDataList: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('hospitalDiagnosisBaseDatas', this.hospitalId).then(() => {
        if (this.$store.state.hospitalModule.successFlag) {
          if (this.$route.name == 'hospital') {
            this.allHospitalSelectedDiagnosisBaseDatas =
              this.$store.state.hospitalModule.hospitalDiagnosisBaseDatas;
            this.defineHospitalDiagnosisBaseDatas();
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.hospitalModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getHospitalDiagnosisBaseDataList();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.hospitalModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getHospitalDiagnosisBaseDataList();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    EditHospitalDiagnosisBaseDataFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      let data = {
        hospitalId: this.hospitalId,
        features: [],
      };
      for (let i = 0; i < this.allHospitalSelectedDiagnosisBaseDatas.length; i++) {
        data.features.push(Number(this.allHospitalSelectedDiagnosisBaseDatas[i].id));
      }
      this.$store.dispatch('editHospitalDiagnosisBaseData', data).then(() => {
        if (this.$store.state.hospitalModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.snackText = ' سانتر های بیمارستان با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.allHospitalSelectedDiagnosisBaseDatas = [];
          this.allHospitalDiagnosisBaseDatas = [];
          this.diagnosisBaseDataModal = false;
          this.getListOfHospitalsWithPagination();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.hospitalModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.EditHospitalDiagnosisBaseDataFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.hospitalModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.EditHospitalDiagnosisBaseDataFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.hospitalModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
